/**
 * @generated SignedSource<<303ca81ad77d31d22653186b5e424d42>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type EnableAndConvertSubtasksForProjectInput = {
  projectId?: string | null;
  conversionMethod?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type EnableAndConvertSubtasksForProjectMutation$variables = {
  input: EnableAndConvertSubtasksForProjectInput;
};
export type EnableAndConvertSubtasksForProjectMutation$data = {
  readonly enableAndConvertSubtasksForProject: {
    readonly project: {
      readonly id: string;
      readonly taskLevels: number | null;
      readonly remainingAutoCalculated: boolean | null;
      readonly useTaskHierarchy: boolean | null;
    } | null;
    readonly projectEdge: {
      readonly node: {
        readonly id: string;
        readonly taskLevels: number | null;
        readonly remainingAutoCalculated: boolean | null;
        readonly useTaskHierarchy: boolean | null;
      } | null;
    } | null;
  } | null;
};
export type EnableAndConvertSubtasksForProjectMutation = {
  variables: EnableAndConvertSubtasksForProjectMutation$variables;
  response: EnableAndConvertSubtasksForProjectMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "taskLevels",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "remainingAutoCalculated",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "useTaskHierarchy",
    "storageKey": null
  }
],
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EnableAndConvertSubtasksForProjectPayload",
    "kind": "LinkedField",
    "name": "enableAndConvertSubtasksForProject",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProjectType",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": (v1/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProjectTypeEdge",
        "kind": "LinkedField",
        "name": "projectEdge",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": (v1/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EnableAndConvertSubtasksForProjectMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EnableAndConvertSubtasksForProjectMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "dc84ecf2bf77a1b7e26b1a4d4acbdd5b",
    "id": null,
    "metadata": {},
    "name": "EnableAndConvertSubtasksForProjectMutation",
    "operationKind": "mutation",
    "text": "mutation EnableAndConvertSubtasksForProjectMutation(\n  $input: EnableAndConvertSubtasksForProjectInput!\n) {\n  enableAndConvertSubtasksForProject(input: $input) {\n    project {\n      id\n      taskLevels\n      remainingAutoCalculated\n      useTaskHierarchy\n    }\n    projectEdge {\n      node {\n        id\n        taskLevels\n        remainingAutoCalculated\n        useTaskHierarchy\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "04084c838e3619b9c90aff1e914302de";

export default node;
